<div class="relative w-full">
    <input
        class="rounded-lg border border-light-blue focus:outline-light-blue px-2 h-32px py-2.5 sm:min-w-150px w-full pl-10 bg-no-repeat bg-left"
        style="background-image: url('./assets2023/img/icons/calendar.svg'); background-position-x: 8px;"
        [placeholder]="placeholder"
        angular-mydatepicker
        name="mydate"
        (click)="dp.toggleCalendar()"
        [(ngModel)]="myDpModel"
        (ngModelChange)="onMyDpModelChange()"
        [options]="myDpOptions"
        locale="es"
        #dp="angular-mydatepicker"
    >
</div>
